import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';
import { push } from 'connected-react-router';

import Page1 from './FormPages/Page1';
import Page2 from './FormPages/Page2';
import ClientInfo from './FormPages/ClientInfo';
import Page3 from './FormPages/Page3';
import WeeklyActivityLevel from './FormPages/WeeklyActivityLevel';
import WeightHeight from './FormPages/WeightHeight';
import Smoking from './FormPages/Smoking';
import Alcohol from './FormPages/Alcohol';
import AlcoholAuditC from './FormPages/AlcoholAuditC';
import AllResults from './FormPages/AllResults';
import Exists from './FormPages/Exists';
import Sorry from './FormPages/Sorry';
import ChangePage from '../../Actions/Register/changePage';

import api from '../../lib/api';
import { processLogin } from '../../Actions/Dashboard/login';
import { checkRegistration } from '../../Actions/Password/register';


function parseQuery(queryString) {
  const query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i += 1) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${(value || "")}${expires}; path=/`;
}

function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

class RegForm extends React.Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.submitValues = this.submitValues.bind(this);
    this.dashboard = this.dashboard.bind(this);
    this.sorryPage = this.sorryPage.bind(this);
    this.checkReg = this.checkReg.bind(this);
    this.checkLoggedIn = this.checkLoggedIn.bind(this);
  }

  nextPage() {
    let page = this.props.page + 1;
    if (this.props.page === 11 && this.props.units_per_week < 1) {
      page = this.props.page + 2;
    }
    if (this.props.page === 8 && this.props.alcohol_more_question.toLowerCase() === 'no') {
      page = this.props.page + 2;
    }
    if (this.props.page === 8 && this.props.auditc_score <= 5) {
      page = this.props.page + 2;
    }

    this.props.dispatch(ChangePage(page));
  }

  previousPage() {
    let page = this.props.page - 1;
    if (this.props.page === 10 && (this.props.units_per_week < 1 || this.props.auditc_score <= 5 || this.props.alcohol_more_question.toLowerCase() === 'no')) {
      page = this.props.page - 2;
    }
    if (this.props.page === 11) {
      this.props.dispatch(ChangePage(3));
    } else {
      this.props.dispatch(ChangePage(page));
    }
  }

  sorryPage() {
    // window.location = '/sorry';
    this.props.dispatch(ChangePage(12));
  }

  submitValues(values) {
    const dobDate = moment(values.client.dob);
    const newVals = values;
    newVals.client.dob = dobDate.format('YYYY-MM-DD');
    const qs = parseQuery(window.location.search);
    const { hash } = qs;
    if (hash) newVals.hash = hash;
    api.postRegistration(newVals, () => {
      if (dataLayer) {  // eslint-disable-line
        if (!getCookie('gadone')) {
          setCookie('gadone', '1', 1);
          dataLayer.push({ event: 'RegSuccess' }); // eslint-disable-line
        }
      }
      this.props.dispatch(processLogin({
        email: values.client.email,
        pw: values.client.password,
        dob: newVals.client.dob,
        noredirect: true,
      }));
    });
  }

  checkLoggedIn(values) {
    const dobDate = moment(values.client.dob);
    const data = {
      email: values.client.email,
      dob: dobDate.format('YYYY-MM-DD'),
      values: values
    };
    api.sendPost(`/clients/check-client`, data, (error, response) => {
      if (error) return console.error(error);
      if (response.data.exists === true) {
        return;
      } else {
        this.submitValues(data.values)
      }
    });
  }

  checkReg(values) {
    const dobDate = moment(values.client.dob);
    const data = {
      email: values.client.email,
      dob: dobDate.format('YYYY-MM-DD'),
    };
    this.props.dispatch(checkRegistration(data));
  }

  dashboard() {
    // this.props.dispatch(push('/dashboard'));
    // window.location = '/dashboard';
    window.location = 'https://my.livewelldorset.co.uk';
  }

  render() {
    const { page } = this.props;

    return (
      <div className="large-wrap">
        <div className="ga-script">
          <script>
            ga('set', 'page', '/register-step-{page}.html');
            ga('send', 'pageview');
          </script>
        </div>

        {page === 1 && <Page1 onSubmit={this.nextPage}/>}
        {page === 2 && (
          <Page2
            onSubmit={this.nextPage}
            onNoConsent={this.sorryPage}
          />
        )}
        {page === 3 && (
          <ClientInfo
            previousPage={this.previousPage}
            onSubmit={this.checkReg}
            how_a={this.props.how_a}
            how_b={this.props.how_b}
            how_c={this.props.how_c}
            disability={this.props.disability}
            learning_disability={this.props.learning_disability}
            mental_health_user={this.props.mental_health_user}
            pregnant={this.props.pregnant}
            gender={this.props.gender}
          />
        )}
        {page === 4 && <Page3 previousPage={this.previousPage} onSubmit={this.nextPage}/>}
        {page === 5 && <WeeklyActivityLevel previousPage={this.previousPage} onSubmit={this.nextPage} activity={this.props.activityLevel} />}
        {page === 6 && <WeightHeight previousPage={this.previousPage} onSubmit={this.nextPage} weight={this.props.weight} height={this.props.height} dispatch={this.props.dispatch}/>}
        {page === 7 &&
          <Smoking
            previousPage={this.previousPage}
            smoking={this.props.smoking}
            smokingAmount={this.props.smokingAmount}
            smokingType={this.props.smokingType}
            onSubmit={this.nextPage}
          />
        }
        {page === 8 && <Alcohol previousPage={this.previousPage} onSubmit={this.nextPage} units={this.props.units_per_week} />}
        {page === 9 && <AlcoholAuditC previousPage={this.previousPage} onSubmit={this.nextPage}/>}
        {page === 10 &&
          <AllResults
            previousPage={this.previousPage}
            activity={this.props.activityLevel}
            height={this.props.height}
            weight={this.props.weight}
            ethnicity={this.props.ethnicity}
            smoking={this.props.smoking}
            pregnant={this.props.pregnant}
            score={this.props.auditc_score}
            smokingstop={this.props.smokingstop}
            units={this.props.units_per_week}
            smokingtype={this.props.smokingType}
            smokingamount={this.props.smokingAmount}
            dispatch={this.props.dispatch}
            onSubmit={this.checkLoggedIn}
            dashboard={this.dashboard}
          />
        }

        {page === 11 && <Exists previousPage={this.previousPage} />}
        {page === 12 && <Sorry previousPage={() => { this.props.dispatch(ChangePage(1)); }} />}
      </div>
    );
  }
}

const selector = formValueSelector('registration');

RegForm.propTypes = {
  gender: PropTypes.string.isRequired,
  activityLevel: PropTypes.number.isRequired,
  weight: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  smoking: PropTypes.string.isRequired,
  ethnicity: PropTypes.string.isRequired,
  smokingType: PropTypes.string.isRequired,
  smokingAmount: PropTypes.string.isRequired,
  how_a: PropTypes.string.isRequired,
  how_b: PropTypes.string.isRequired,
  how_c: PropTypes.string.isRequired,
  disability: PropTypes.string.isRequired,
  learning_disability: PropTypes.string.isRequired,
  mental_health_user: PropTypes.string.isRequired,
  pregnant: PropTypes.string.isRequired,
  smokingstop: PropTypes.string.isRequired,
  auditc_score: PropTypes.number.isRequired,
  units_per_week: PropTypes.number.isRequired,
  alcohol_more_question: PropTypes.oneOf(['Yes', 'No']).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(state => ({
  gender: selector(state, 'client[gender]') || 'Prefer not to say',
  activityLevel: parseInt(selector(state, 'assessment[activity_times]'), 10) || 0,
  auditc_score: parseInt(selector(state, 'assessment[alcohol_score]'), 10) || 0,
  units_per_week: parseInt(selector(state, 'assessment[alcohol_units_per_week]'), 10) || 0,
  alcohol_more_question: selector(state, 'assessment[alcohol_more_question]') || '',
  weight: parseFloat(selector(state, 'assessment[weight_weight]')) || 0,
  height: parseFloat(selector(state, 'assessment[weight_height]')) || 0,
  smoking: selector(state, 'assessment[smoking]') || '',
  smokingType: selector(state, 'assessment[smoking_type_id]') || '',
  ethnicity: selector(state, 'client[ethnicity]') || '',
  smokingAmount: selector(state, 'assessment[smoking_quantity]') || '0',
  smokingstop: selector(state, 'pathway_smoking') || '',
  how_a: selector(state, 'client[how_a]') || '',
  how_b: selector(state, 'client[how_b]') || '',
  how_c: selector(state, 'client[how_c]') || '',
  disability: selector(state, 'client[disability]') || '',
  learning_disability: selector(state, 'client[learning_disability]') || '',
  mental_health_user: selector(state, 'client[mental_health_user]') || '',
  pregnant: selector(state, 'client[activity_pregnant]') || 'No',
  page: state.registrationPage,
}))(RegForm);



// WEBPACK FOOTER //
// ./src/Components/Register/index.jsx